import moment from "moment";

export default class ReportVacationReport_Settings {

    // View settings
    public userId          : ID
    public year            : string


    constructor(data: any) {
        this.userId           = _.get(data, "userId", null)
        this.year             = _.get(data, "year", moment().format("YYYY"));
    }

    get reportTitle() {
        return this.year
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            userId           : this.userId,
            year             : this.year.format("YYYY")
        }

        return result
    }
}
